const SITE_ROOT = '/';
const BACKOFFICE_ROOT = '/backoffice';

export default {
  SITE: {
    HOME: SITE_ROOT,
    CHANGE_PASSWORD: '/change-password/:token',
  },
  BACKOFFICE: {
    LOGIN: BACKOFFICE_ROOT,
    HOME: `${BACKOFFICE_ROOT}/home`,

    // User
    REGISTER_USER_LIST: `${BACKOFFICE_ROOT}/register/user`,
    REGISTER_USER_CREATE: `${BACKOFFICE_ROOT}/register/user/add`,
    REGISTER_USER_UPDATE: `${BACKOFFICE_ROOT}/register/user/update/:id`,

    // Profile
    REGISTER_PROFILE_LIST: `${BACKOFFICE_ROOT}/register/profile`,
    REGISTER_PROFILE_CREATE: `${BACKOFFICE_ROOT}/register/profile/add`,
    REGISTER_PROFILE_UPDATE: `${BACKOFFICE_ROOT}/register/profile/update/:id`,

    // System Menu Item
    REGISTER_SYSTEM_MENU_ITEM_LIST: `${BACKOFFICE_ROOT}/register/system-menu-item`,
    REGISTER_SYSTEM_MENU_ITEM_CREATE: `${BACKOFFICE_ROOT}/register/system-menu-item/add`,
    REGISTER_SYSTEM_MENU_ITEM_UPDATE: `${BACKOFFICE_ROOT}/register/system-menu-item/update/:id`,

    // Menu Item
    REGISTER_MENU_ITEM_LIST: `${BACKOFFICE_ROOT}/register/menu-item`,
    REGISTER_MENU_ITEM_CREATE: `${BACKOFFICE_ROOT}/register/menu-item/add`,
    REGISTER_MENU_ITEM_UPDATE: `${BACKOFFICE_ROOT}/register/menu-item/update/:id`,

    // Work Hours
    REGISTER_SCHEDULES: `${BACKOFFICE_ROOT}/register/schedules`,

    // Client
    REGISTER_CLIENT_LIST: `${BACKOFFICE_ROOT}/register/client`,
    REGISTER_CLIENT_VIEW: `${BACKOFFICE_ROOT}/register/client/:id`,

    // Orders
    ORDER: `${BACKOFFICE_ROOT}/order`,

    // Reports
    REPORTS_ORDERS_PER_DAY: `${BACKOFFICE_ROOT}/report/orders-per-day`,
    REPORTS_MOST_ORDERED_MENU_ITEM: `${BACKOFFICE_ROOT}/report/most-ordered-menu-item`,
    REPORTS_REVENUE_PER_DAY: `${BACKOFFICE_ROOT}/report/revenue-per-day`,
    REPORTS_TOP_FIVE_ORDERED_CLIENTS: `${BACKOFFICE_ROOT}/report/top-five-ordered-clients`,
    REPORTS_NEW_CLIENTS_PER_DAY: `${BACKOFFICE_ROOT}/report/new-clients-per-day`,
  },
};
